<template>
<div>
  
</div>
  <!-- <section class="section-hero section-shaped my-0 test">
    <carousel :perPage="2"  :autoplayHoverPause='true' :autoplay="true" :loop="true">
      <slide v-for="(item,index) in imageoption" :key="index" :isTouch="true" :caption="item.id" :title="item.id">
       <img :src="item.image" class="banner" :value="item.id">
      </slide>
    </carousel>
  </section> -->
</template>

<script>
  export default {
    
    data() {
      return {
        imageoption: [
          {"id":"1","image":"/img/hotels/Le-Meridien-Goa-hotel/1.jpg"},
          {"id":"2","image":"/img/hotels/Le-Meridien-Goa-hotel/2.jpg"},
          {"id":"3","image":"/img/hotels/Le-Meridien-Goa-hotel/3.jpg"},
        ],
      };
    },
    
  };
</script>
<style  scoped>
.section-hero {
  height: 100vh;
}
.test{
  position: relative;
    margin: 12% 5% 0;

}

.banner{
  height: 60%;
  width: 100%;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}
.centered {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color:#fff;
  font-size: 3em;
}

</style>